import { ContextType, createContext, useState } from "react";

import { getApiBaseUrl } from "@/api";
import { storage } from "@/modules/storage";

type App = {
  platformId: string;
  apiUrl: string;
  appIconNames: string[];
  referralCode: string;
};

export const AppContext = createContext({
  platformId: "",
  referralCode: "",
  apiUrl: "",
  appIconNames: [] as string[],
  setPlatformId: (id: string): void => undefined,
  setApiUrl: (url: string): void => undefined,
  setAppIcons: (icons?: string[]): void => undefined,
  setReferralCode: (setReferralCode: string): void => undefined,
  clear: (): void => undefined,
});

export const useAppState = (): ContextType<typeof AppContext> => {
  const [app, setApp] = useState<App>({
    platformId: storage.getItem("platformId") || "",
    apiUrl: getApiBaseUrl(),
    appIconNames: JSON.parse(storage.getItem("iconNames") || "[]"),
    referralCode: storage.getItem("referralCode") || "",
  });

  return {
    platformId: app.platformId,
    apiUrl: app.apiUrl,
    appIconNames: app.appIconNames,
    referralCode: app.referralCode,
    setPlatformId: (id) => {
      if (!id) {
        storage.removeItem("platformId");
      } else {
        storage.setItem("platformId", id);
      }
      setApp({ ...app, platformId: id });
    },
    setApiUrl: (url) => {
      if (!url) {
        storage.removeItem("baseApiUrl");
      } else {
        storage.setItem("baseApiUrl", url);
      }
      setApp({ ...app, apiUrl: url });
    },
    setAppIcons: (icons) => {
      if (!icons) {
        storage.removeItem("iconNames");
      } else {
        storage.setItem("iconNames", JSON.stringify(icons));
      }
      setApp({ ...app, appIconNames: icons || [] });
    },
    setReferralCode: (referralCode) => {
      if (!referralCode) {
        storage.removeItem("referralCode");
      } else {
        storage.setItem("referralCode", referralCode);
      }
      setApp({ ...app, referralCode });
    },
    clear: () => {
      storage.removeItem("platformId");
      storage.removeItem("baseApiUrl");
      storage.removeItem("referralCode");
      setApp({
        ...app,
        platformId: "",
        apiUrl: "",
        referralCode: "",
      });
    },
  };
};
